import { AppSetting } from 'dependencies/appsettings';
import { BlobResponse, createUploader, RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoints } from '../../endpoints';
import { ListApiGateway } from '../types';
import { CodeDescriptionListWire } from './types';
import {
  CodeDescriptionMetadata, CodeDescriptionSearchData, CodeDescriptionSearchModel,
  ModifiedCodeDescription, ModifiedCodeDescriptionWire
} from './types-store';

export const api = {

  getMetadata: async (): Promise<CodeDescriptionMetadata> => {

    const response = await new RemoteAdminData(endpoints.codeDescriptionMetadata)
      .resource<ApiResponse<CodeDescriptionMetadata>>()
      .all();

    return response.data;
  },

  getList: async (startIndex: number, maxResults: number, model: CodeDescriptionSearchModel): Promise<CodeDescriptionListWire> => {

    const response: any = await new RemoteAdminData(endpoints.searchCodeDescription)
      .resource<ApiResponse<CodeDescriptionListWire>>()
      .filter({ startIndex, maxResults })
      .create(model, false);

    const json: ApiResponse<CodeDescriptionListWire> = await response.json();
    return json.data;
  },

  saveChanges: (modifiedItems: ModifiedCodeDescriptionWire[]) => {
    return new RemoteAdminData(endpoints.saveCodeDescription)
      .resource<void>()
      .update(modifiedItems);
  },

  exportToExcel: (startIndex: number, maxResults: number, model: CodeDescriptionSearchModel): Promise<BlobResponse> => {
    return new RemoteAdminData(endpoints.exportCodeDescriptionToExcel)
      .resource<BlobResponse>()
      .filter({ startIndex, maxResults })
      .blob(model);
  }
};

export const codeApiGateway: ListApiGateway<
  CodeDescriptionMetadata,
  CodeDescriptionSearchData,
  ModifiedCodeDescription,
  CodeDescriptionSearchModel
> = {

  getMetadata: () => {
    return api.getMetadata();
  },

  getList: (startIndex: number, maxResults: number, model: CodeDescriptionSearchModel) => {

    return api.getList(startIndex, maxResults, model);
  },

  saveChanges: (modifiedItems: ModifiedCodeDescription[]) => {
    const modifiedItemsWire = modifiedItems
      .filter(item => !item.onlyWhitespace)
      .map(item => ({
        id: item.id,
        codetable: item.codetable,
        language: item.language,
        description: item.description.trim(),
        ...(item.longDescription !== undefined &&
          item.longDescription.trim() !== '' &&
          { longDescription: item.longDescription.trim() })
      }));

    return api.saveChanges(modifiedItemsWire);
  },

  exportToExcel: (startIndex: number, maxResults: number, model: CodeDescriptionSearchModel): Promise<BlobResponse> => {

    return api.exportToExcel(startIndex, maxResults, model);
  },

  createUploadRequest: () => {
    return createUploader(`${endpoints.importCodeDescriptionFromExcel}?api-version=1.0`, 'POST', AppSetting.AdminApiBaseUrl);
  }
};
